import {
    ApiOutlined,
    BarChartOutlined,
    DollarCircleOutlined,
    FileOutlined,
    FileSearchOutlined,
    FilterOutlined,
    FunnelPlotOutlined,
    LoginOutlined,
    SaveOutlined,
    SettingOutlined,
    ShopOutlined,
    TeamOutlined,
    ThunderboltOutlined,
} from '@ant-design/icons'
import {MenuItem} from 'common/components/sidebar/Sidebar.tsx'

export const menuTabs: MenuItem[] = [
    {
        label: 'Report Builder',
        key: 'report-builder',
        url: 'report-builder',
        icon: <BarChartOutlined/>,
    },
    {
        label: 'Saved Reports',
        key: 'report',
        url: 'report',
        icon: <SaveOutlined/>,
    },
    {
        label: 'Agency',
        key: 'agency',
        url: 'agency',
        icon: <ShopOutlined/>,
    },
    {
        label: 'Accounts',
        key: 'account',
        url: 'account',
        icon: <TeamOutlined/>,
    },
    {
        label: 'SSP',
        key: 'ssp',
        url: 'ssp',
        icon: <ApiOutlined/>,
    },
    {
        label: 'Filter Lists',
        key: 'filter-list',
        url: 'filter-list',
        icon: <FilterOutlined/>,
    },
    {
        label: 'Global Filters',
        key: 'filter-list-global',
        url: 'filter-list-global',
        icon: <FunnelPlotOutlined/>,
    },
    {
        label: 'Transactions',
        key: 'agency-transactions',
        url: 'agency-transactions',
        icon: <DollarCircleOutlined/>,
    },
    {
        label: 'Events',
        key: 'tracker-event',
        url: 'tracker-event',
        icon: <ThunderboltOutlined/>,
    },
    // {
    //     label: 'Tracker Statistics',
    //     key: 'tracker-event-stats',
    //     url: 'tracker-event-stats',
    //     icon: <DatabaseOutlined/>,
    // },
    {
        label: 'Tracker Reports',
        key: 'tracker-event-report',
        url: 'tracker-event-report',
        icon: <SaveOutlined/>,
    },
    {
        label: 'Change Log',
        key: 'logs',
        url: 'logs',
        icon: <FileSearchOutlined/>,
    },
    {
        label: 'Auth Logs',
        key: 'auth-logs',
        url: 'auth-logs',
        icon: <LoginOutlined/>,
    },
    {
        label: 'Settings',
        key: 'settings',
        url: 'settings',
        icon: <SettingOutlined/>,
    },
    {
        label: 'Mandatory Fields',
        key: 'mandatory-fields',
        url: 'mandatory-fields',
        icon: <FileOutlined/>,
    },
]
